import { Box } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { HomeIcon, PromoTagIcon, HomeFillIcon, PromoTagFillIcon, PresenceContentIcon, PresenceContentFillIcon } from 'Asset/icon';
import { TextRegular } from 'UiKit/typography';
import { Condition } from 'Component/others';
import getSelectedView from 'Helper/getSelectedView';

import styles from './styles.module.css';

const BottomNavigationBar = () => {
  const { t } = useTranslation('host-home');
  const navigate = useNavigate();
  const getPath = useLocation();

  const { isHomeActive, isPromoActive, isPresenceContentActive } = getSelectedView(getPath.pathname);

  const handleNavigateHome = () => {
    navigate('/host');
  };

  const handleNavigatePromo = () => {
    navigate('/host/stock-promo');
  };

  const handlePresenceContent = () => {
    navigate('/host/presence-content');
  };

  return (
    <Box className={styles['bottom-navbar__container']}>
      {/* Stok & Promo Button */}
      <Box className={styles['bottom-navbar__button']} onClick={handleNavigatePromo}>
        <Condition statement={isPromoActive} fallback={<PromoTagIcon color="var(--color-semantic-text)" size="20" />}>
          <PromoTagFillIcon color="var(--color-primary60)" size="20" />
        </Condition>
        <TextRegular fontSize="14" className={isPromoActive && styles['bottom-navbar__button--active']}>
          {t('navbar.stock_promo')}
        </TextRegular>
      </Box>

      {/* Home Button */}
      <Box className={styles['bottom-navbar__button']} onClick={handleNavigateHome}>
        <Condition statement={isHomeActive} fallback={<HomeIcon color="var(--color-semantic-text)" size="20" />}>
          <HomeFillIcon color="var(--color-primary60)" size="20" />
        </Condition>
        <TextRegular fontSize="14" className={isHomeActive && styles['bottom-navbar__button--active']}>
          {t('navbar.home')}
        </TextRegular>
      </Box>

      {/* Presence Content Button */}
      <Box className={styles['bottom-navbar__button']} onClick={handlePresenceContent}>
        <Condition statement={isPresenceContentActive} fallback={<PresenceContentIcon color="var(--color-semantic-text)" size="20" />}>
          <PresenceContentFillIcon color="var(--color-primary60)" size="20" />
        </Condition>
        <TextRegular fontSize="14" className={isPresenceContentActive && styles['bottom-navbar__button--active']}>
          {t('navbar.attendance_content')}
        </TextRegular>
      </Box>
    </Box>
  );
};

export default BottomNavigationBar;
